import type { AxiosRequestConfig } from 'axios'

import { getHost } from '@b-stock/fe-core/bstock-next/helpers'
import { axiosInstance } from '@b-stock/fe-core/bstock-next/queries'

type BridgeEntAuction = {
  auctionId: string
  winningBidAmount: number
  startPrice: number
  numberOfBids: number
  closed?: boolean
  canceled?: boolean
  endTime?: string
  buyerBidStatus: 'HAS_NOT_BID' | 'WINNING' | 'LOSING'
}

// Bridge API client is broken as of this writing (Apr 2025)
const getEntAuctions = async (
  auctionIds: string[],
  axiosConfig: AxiosRequestConfig
): Promise<BridgeEntAuction[]> => {
  if (!auctionIds.length) return []

  const { data } = await axiosInstance.get<BridgeEntAuction[]>(
    `${getHost('BRIDGE')}/v1/ent-auctions`,
    {
      ...axiosConfig,
      params: { auctionIds: auctionIds.join(',') },
    }
  )

  return data
}

export type { BridgeEntAuction }
export default getEntAuctions
